import { render, staticRenderFns } from "./Grouping.vue?vue&type=template&id=3bf47ba1&"
import script from "./Grouping.vue?vue&type=script&lang=js&"
export * from "./Grouping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports